<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { Button, Dialog, ScrollArea } from '@rapoo/element'
  import { useLocaleStore } from '@/stores'

  interface UpdateLogItem {
    version: string
    data: string
    date: string
  }

  const isOpen = defineModel<boolean>('open')
  watch(
    () => isOpen.value,
    async (val) => {
      if (val) {
        const res = await window.electronAPI?.getReleaseNotes(language.value)
        if (res) {
          formatReleaseNotes(res)
        }
      }
    },
  )
  const updateLogs = ref<UpdateLogItem[]>([])
  const formatReleaseNotes = (res: Record<string, { content: string; date: string }>) => {
    updateLogs.value = []
    for (const version in res) {
      const item = res[version]
      updateLogs.value.push({
        version,
        data: item.content,
        date: item.date,
      })
    }
  }

  const localeStore = useLocaleStore()
  const { language } = storeToRefs(localeStore)
</script>

<template>
  <Dialog v-model:open="isOpen" content-class="w-[420px] sm:max-w-[420px] p-4">
    <div class="flex flex-col">
      <h3 class="text-center text-2xl-medium text-black-white">
        {{ $t('setting.about.update.updateLogDialog.title') }}
      </h3>
      <ScrollArea class="max-h-38">
        <div class="mt-4 space-y-4">
          <div v-for="item in updateLogs" :key="`${item.version}-${item.date}`" class="space-y-2">
            <p class="text-l-medium text-black-white">{{ item.version }}（{{ item.date }}）</p>
            <ul class="space-y-1">
              <li class="text-m-medium text-text-glass-default leading-5 whitespace-pre-wrap">
                {{ item.data }}
              </li>
            </ul>
          </div>
        </div>
      </ScrollArea>
      <Button class="w-full mt-6" color="black" size="lg" @click="isOpen = false">
        {{ $t('common.confirm') }}
      </Button>
    </div>
  </Dialog>
</template>
